import { caseApi } from 'modules/cm/api';
import { CaseId } from 'modules/cm/api/cases/types';
import { Dispatch } from 'redux';
import { Property } from '../../RepaymentStrategy';

const addNewPropertyUseCase = (caseId: CaseId) => {
  const api = caseApi(caseId).repaymentStrategyApi.property;
  return async (dispatch: Dispatch): Promise<Property | undefined> => {
    try {
      const createdProperty = await api.create();

      return createdProperty;
    } catch (error) {
      throw error;
    }
  };
};

export default addNewPropertyUseCase;
